import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {SharedModule} from "./shared/shared.module";
import {AuthInterceptor} from "./shared/interceptors/auth-interceptor";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {ContentInterceptor} from "./shared/interceptors/content-interceptor";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS} from "@angular/material/snack-bar";

/**
 * Interceptor list
 */
const interceptorProviders = [
  // This should mostly be the first (last response interceptor), as it parses the response body
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ContentInterceptor,
    multi: true
  },
  // As this doesn't map anything on the response or parse the request it can be anywhere
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  },
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule
  ],
  providers: [
    interceptorProviders,
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 10000
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
